import Debouncer from '../../lib/Debouncer';

interface ScrolledOptions {
    scrolledClass: string;
    scrolledDistanceClass: string;
    scrollDistanceDown: string | number;
    scrollDistanceUp: number;
}

class Scrolled {
    private options: ScrolledOptions;
    private scrollDistanceDownValue: number;
    private bodyClassList: DOMTokenList;
	private triggerPoint: number;

    constructor(options: ScrolledOptions) {
        this.options = options;
        this.scrollDistanceDownValue = 0;
        this.bodyClassList = document.body.classList;
		this.triggerPoint = window.scrollY;

        this.updateScrollDistanceDownValue();

        const scrollDebouncer = new Debouncer(this.onScroll.bind(this));
        const resizeDebouncer = new Debouncer(this.updateScrollDistanceDownValue.bind(this));

        window.addEventListener('resize', resizeDebouncer.run);
        window.addEventListener('scroll', scrollDebouncer.run);
        resizeDebouncer.runNow();
        scrollDebouncer.runNow();
    }

    private updateScrollDistanceDownValue() {
        console.log('updateScrollDistanceDownValue', this.scrollDistanceDownValue);
        if (typeof this.options.scrollDistanceDown === 'string') {
            const element = document.querySelector(this.options.scrollDistanceDown);
            if (element) {
                this.scrollDistanceDownValue = element.clientHeight;
            }
        } else {
            this.scrollDistanceDownValue = this.options.scrollDistanceDown;
        }
    }

    private onScroll() {
		const scrollTop = window.scrollY || document.body.scrollTop;
		const diff = window.scrollY - this.triggerPoint;

		if (this.options.scrolledClass !== undefined) {
			this.bodyClassList.toggle(this.options.scrolledClass, scrollTop > 0);
		}

		if (diff > 0 && diff >= this.scrollDistanceDownValue) {
			// Scroll down
			this.triggerPoint = scrollTop;
			this.bodyClassList.add(this.options.scrolledDistanceClass);
		} else if (diff < 0 && 0 - diff >= this.options.scrollDistanceUp) {
			// Scroll up
			this.triggerPoint = scrollTop;
			this.bodyClassList.remove(this.options.scrolledDistanceClass);
		}
    }
}

export default Scrolled;